import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { layerlist } from 'src/app/constant/maplayers';
import { applyRememberedMapLayer, rememberMapLayer } from 'src/app/constant/map-layer-memory';
import { PlayerStoryComponent } from 'src/app/modal/player-story/player-story.component';
import { CityMapService } from 'src/app/services/city-map.service';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { DataService } from 'src/app/services/data.service';
import { InfoBarMapViewService } from 'src/app/services/info-bar-map-view.service';
import { MapService } from 'src/app/services/map.service';
import { ToastService } from 'src/app/services/toast.service';
import { AddContentComponent } from '../../content-creator/add-content/add-content.component';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { CityWebDataService } from 'src/app/services/city-web-data.service';
import { Subscription } from 'rxjs';
import { CategoryPlayerViewModalComponent } from 'src/app/modal/category-player-view-modal/category-player-view-modal.component';
import { PlayerViewService } from 'src/app/services/player-view.service';
import { forkJoin } from 'rxjs';
import { NoteListComponent } from 'src/app/modal/note-list/note-list.component';
import {
  biomeRanges,
  elevationRanges,
  WORLD_TUMBLER_URL,
} from 'src/app/constant/constant';
import { MapDataService } from 'src/app/services/map-data.service';
import { FavoriteRecord } from '../../content-creator/add-content/models/content.model';
import { FavoriteRecordsService } from 'src/app/services/favorite-records.service';
import { WikiService } from 'src/app/services/wiki.service';
import { ContentData } from '../../content-creator/add-content/models/content.model';
import { PlaceContentModalComponent } from 'src/app/modal/place-content-modal/place-content-modal.component';
import { StoreLinkService } from 'src/app/services/marketplace/store-link.service';

@Component({
    selector: 'app-map-player-view',
    templateUrl: './map-player-view.component.html',
    styleUrls: ['./map-player-view.component.scss', '../../mapview/map-screen.shared.scss'],
    standalone: false
})
export class MapPlayerViewComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  map_id: any;
  game_id: any;
  playerlistdata: any;
  newLayers: any;
  map_name: string = '';

  sideInfoBar: boolean = false;
  isMenu1Open = false;
  objectData: any = null;
  firstToggle = false;
  isDisplayCityMap: boolean = false;
  isMenu2Open = false;
  optionText: string = null;
  showDropdown: boolean = false;
  openContentCreationCity: boolean = false;
  favroiteRecords: FavoriteRecord[] = [];
  selectedIcon: any;
  @ViewChild('map', { read: ElementRef, static: true }) mapElement: ElementRef;
  @ViewChild('cityMap', { read: ElementRef, static: true })
  cityMapElement: ElementRef;
  @ViewChild('sideContent', { read: ElementRef, static: true })
  sideInfoElement: ElementRef;
  layerlist = layerlist;
  historyRecords = null;
  citySharedLocationArr: any[] = [];
  cityOpenPanel: boolean = false;
  listOfSavedItems: any;
  openContentCreation: boolean = false;
  cityCode: any;
  openPinPanel: boolean;
  map: any;
  isHistoryAdded: boolean = false;
  character_id: string;
  dynamicFavroiteForm: FormGroup;
  cityFavroiteRecords: any[] = [];
  dynamicCityFavroiteForm: FormGroup;
  userId: any;
  contentCreatorData: ContentData[] = [];
  cityPlayerContentData: any[] = [];
  playerCreatorData: any[] = [];
  listOfCitySharedLocation: any[] = [];
  coordsArrOfPointsUser: { coords: [number, number][], idArr: number[], content: ContentData[] };
  coordsArrOfPointsUserCity: any;
  coordsArrOfPointsPlayer: any;
  historyCityRecords: any[] = [];
  cityContentCreatorData: any;
  cultureData: any;
  windowmapheight: number | string = '123px';
  infoBarSubscription: Subscription;
  cityMapVisibleSubscription: Subscription;
  isCultureVisible: boolean = true;
  isCityDetailsVisible: boolean = false;
  cityData: any;
  isMapDetailsVisible: boolean = false;
  legendData: any = [];
  currentLayerName: string = 'state';
  cellDetailsOrder: string[] = [
    'City Present',
    'Elevation',
    'Depth',
    'Population',
    'State',
    'Province',
    'Culture',
    'Religion',
    'Biome',
    'Land Area',
    'Geozone',
    'Natural Resources',
    'Bonus Resources',
    'Farm Resources',
    'Mineral Resources',
    'Special Resources',
  ];

  cityDetailsSortArray: string[] = [
    'City Name',
    'Population',
    'District',
    'Capitol',
    'Port',
    'Citadel',
    'City Walls',
    'Market Place',
    'Religious Center',
    'Shanty Town',
  ];
  selectedOption: string = '';
  showItemDetailsBox: boolean = false;
  showMenu = false;
  menuPosition = { x: 0, y: 0 };
  newFavoriteCoordinates: [number, number] = [0, 0];
  historySubscriprtion: Subscription;
  isRemovingFavorite: number | null = null;
  isOnlyBack: boolean = false;
  isPlaying: boolean = true;
  currentLayerWikiName: string = 'state';
  elevationRanges: string[] = elevationRanges;
  biomeRanges: string[] = biomeRanges;
  isLoading: boolean = false;
  headerTitle: string = '';
  displayHeader: boolean = false;
  redirect_coords: string = '';

  constructor(
    private mapService: MapService,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private dataService: DataService,
    private storeLinks: StoreLinkService,
    private infoBarService: InfoBarMapViewService,
    private toastService: ToastService,
    private cityMapService: CityMapService,
    private coordService: CoordinatesService,
    private formBuilder: FormBuilder,
    private currentUserService: CurrentUserService,
    private cityDataService: CityWebDataService,
    private playerViewService: PlayerViewService,
    private mapDataService: MapDataService,
    private wikiService: WikiService,
    private favoriteRecordsService: FavoriteRecordsService,
    private cdr: ChangeDetectorRef,
  ) {}
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    // The map fills the window below the app header (no site footer here).
    // Measured from the header, not the map's own position: arriving from a
    // scrolled page (e.g. the Maps list) made that position, and so the map
    // height, wrong.
    const headerHeight = document.querySelector('app-header')?.getBoundingClientRect().height || 48;
    this.windowmapheight = Math.max(320, window.innerHeight - headerHeight) + 'px';
  }
  ngAfterViewInit(): void {
    this.mapService.removeOldMap();
    this.resetLayers();
    this.getRouteParams();
    this.getRouteQueryParams();
    this.getMapName();
    this.fetchContentCreatorData();
    this.setupLayerDetails();
    this.setupCoordinateHistory();
    this.getPlayerLocationHistory(false);
  }

  private initializeMap(): void {
    this.mapService.map.setTarget(
      this.elementRef.nativeElement.querySelector('#map'),
    );
  }

  private getMapName(): void {
    this.mapService.mapList$.subscribe({
      next: (data) => {
        if (data) {
          this.map_name = data.find(
            (map) => map.map_id == this.map_id,
          )?.map_name;
        } else {
          this.mapService.getMapList();
        }
      
          this.cdr.detectChanges();},
      error: (error) => {
        console.error('Error fetching map list:', error);
      
          this.cdr.detectChanges();},
    });
  }

  getRouteQueryParams(): void {
    this.route.queryParams.subscribe((params) => {
      this.isOnlyBack = false;
      if (params['isonlyback'])
        this.isOnlyBack = params['isonlyback'] == 'true';

      if (params['displayHeader'])
        this.displayHeader = params['displayHeader'] == 'true';
      let loadMainMap = false;
      if (params['loadMainMap']) {
        loadMainMap = params['loadMainMap'] == 'true';
      }
      let isCityVisited = false;
      if (params['isCityVisited']) {
        isCityVisited = params['isCityVisited'] == 'true';
      }
      let isCityExited = false;
      if (params['isCityExited']) {
        isCityExited = params['isCityExited'] == 'true';
      }
      if (params['redirect_coords'] && params['redirect_coords'] != 'null' && params['redirect_coords'] != 'undefined') {
        this.redirect_coords = params['redirect_coords'];
      }

      if (
        this.character_id &&
        this.game_id &&
        this.game_id !== 'null' &&
        this.game_id !== 'undefined' &&
        !this.displayHeader
      ) {
        this.headerTitle =
          'During active play, Game Master controls token movement.';
      }
      this.fetchCharacterDetails(
        this.isOnlyBack,
        loadMainMap,
        isCityVisited,
        isCityExited,
      );
    
          this.cdr.detectChanges();});
  }

  private getRouteParams(): void {
    this.map_id = this.route.snapshot.paramMap.get('map_id');
    this.game_id = this.route.snapshot.paramMap.get('game_id');
    this.getLegendDataLocal(this.map_id, this.currentLayerName);
    this.getMapName();
    if (this.game_id === 'undefined' || this.game_id === 'null') {
      this.game_id = null;
    }
    this.character_id = this.route.snapshot.paramMap.get('charcter_id');
    this.fetchFavoriteLocations();
  }

  private fetchCharacterDetails(
    isOnlyBack: boolean,
    loadMainMap: boolean,
    isCityVisited: boolean,
    isCityExited: boolean,
  ): void {
    this.dataService
      .Getcharacterdetailbychar_id(this.character_id)
      .subscribe((data: any) => {
        if (data) {
          this.playerlistdata = data.character_details;
          if (this.game_id)
            this.mapService.game_system =
              this.playerlistdata.game_details[0]?.game_system;

          if ((loadMainMap || isOnlyBack || isCityVisited || isCityExited) || !this.playerlistdata.is_in_city) {
            this.initializeMap();
          } else {
            this.router.navigate(
              [
                '/city-map-view/' +
                  this.playerlistdata.city_id +
                  '/' +
                  this.map_id +
                  '/' +
                  (this.game_id ? this.game_id : 'null') +
                  '/' +
                  (this.character_id ? this.character_id : 'null'),
              ],
              {
                queryParams: {
                  token: this.playerlistdata.cropped_image,
                  isLoadToken: true,
                  isPlaceToken: this.playerlistdata.current_location,
                  backRoute: 'map-view-player',
                  // dead characters can't move either (this check left it out)
                  isMovable:
                    !(
                      this.playerlistdata.game_details[0]?.is_active ||
                      this.playerlistdata.is_retired ||
                      this.playerlistdata.is_dead
                    ) || false,
                },
              },
            );
          }
          const obj = {
            map_id: this.map_id,
            type: 'Player',
            game_id: this.game_id,
            character_id: this.character_id,
            citycode: this.cityCode,
            is_movement:
              !this.playerlistdata.is_dead &&
              !this.playerlistdata.is_retired &&
              !this.playerlistdata.game_details[0]?.is_active &&
              isOnlyBack === false
                ? true
                : false,
            cityBackNavigate: 'map-view-player',
            isFitExtent: false,
          };

          this.isPlaying =
            !(
              this.playerlistdata.game_details[0]?.is_active ||
              this.playerlistdata.is_retired ||
              this.playerlistdata.is_dead
            ) || false;

          this.mapService.loadlayers(obj);
          // show the remembered layer now that the map's layers exist
          this.mapService.filterAndToggleLayers(this.filterlayers(layerlist));
          this.mapService.bindSingleClick();
          if (this.redirect_coords) {
            this.mapService.zoomToRedirectCoordsMain(this.redirect_coords);
          }
          localStorage.setItem('mapObject', JSON.stringify(obj));
          if (isOnlyBack) {
            this.playerlistdata.not_movable = true;
          }
          this.mapService.addListofPoints(this.playerlistdata);
        }
      
          this.cdr.detectChanges();});
  }

  private fetchContentCreatorData(): void {
    this.dataService
      .getContentDataByMapId(this.userId, this.map_id)
      .subscribe((data: { results: ContentData[] }) => {
        ;
        if (data.results) {
          ;
          this.contentCreatorData = data.results;
          this.coordsArrOfPointsUser = this.extractCoordinatesFromPins(
            this.contentCreatorData,
          );
          ;
          this.mapService.addDifferentContentPin(
            false,
            this.coordsArrOfPointsUser,
            false,
          );
        }
      
          this.cdr.detectChanges();});
  }

  private extractCoordinatesFromPins(contentData: ContentData[]): { coords: [number, number][], idArr: number[], content: ContentData[] } {
    const coords: [number, number][] = [];
    const idArr: number[] = [];
    const content: ContentData[] = [];
    (contentData || [])
      .filter((ele) => ele.pins && ele.pins.length > 0)
      .forEach((ele) => {
        ele.pins
          .filter((pin) => String(pin.map_id) === String(this.map_id) && !pin.city_id)
          .forEach((pin) => {
            coords.push([
              parseFloat(pin.latitude as any),
              parseFloat(pin.longitude as any),
            ]);
            idArr.push(pin.id);
            content.push(ele);
          });
      });
    return { coords, idArr, content };
  }


  private setupLayerDetails(): void {}

  createContent() {
    this.isLoading = true;
  forkJoin({
    cellData: this.dataService.getCustomCellData({
        latitude: this.newFavoriteCoordinates[1],
        longitude: this.newFavoriteCoordinates[0],
        map_code: this.map_id,
      }),
      mapGenre: this.dataService.getMapGenre(this.map_id, this.game_id? this.game_id: null)
    }).subscribe({
      next: (result: any) => {
        this.isLoading = false;
        const data = result.cellData;
        const genreData = result.mapGenre;

        if (data) {
          const elevationRanges = this.buildElevationRange(data);
          const biomeRanges = this.processBiomeRanges(data);
          const payload: any = {
            biome: biomeRanges,
            elevation: elevationRanges,
          };

          if (genreData?.res) {
            payload.game_genre = genreData.res;
          }
          if (genreData?.game_system) {
            payload.game_system = genreData.game_system;
          }

          this.passFinalObjectToContentPage(payload);
        }
      
          this.cdr.detectChanges();},
      error: (err) => {
        this.isLoading = false;
        console.error(err);
      
          this.cdr.detectChanges();},
    });
  }

  passFinalObjectToContentPage(queryParamsObject: any) {
    this.mapDataService.setContentRangesData(queryParamsObject);
    this.router.navigate(['/add-edit-content'], {
      queryParams: {
        map_id: this.map_id,
        character_id: this.character_id,
        backwordNavigate: this.router.url,
        coordinates: this.newFavoriteCoordinates?.join(','),
      },
    });
  }

  buildElevationRange(data: any) {
    const elevation =
      data?.elevation > 0 ? data.elevation : (data?.depth ?? NaN);

    // Always build the base object first
    const result: Record<string, boolean> = this.elevationRanges.reduce(
      (acc, range) => {
        acc[range] = false;
        return acc;
      },
      {} as Record<string, boolean>,
    );

    // Explicit early return for invalid elevation
    if (typeof elevation !== 'number' || Number.isNaN(elevation)) {
      return result;
    }

    for (const range of this.elevationRanges) {
      const match = range.match(/-?\d+/g);
      if (!match || match.length < 2) continue;

      const min = Number(match[0]);
      const max = Number(match[1]);

      if (elevation >= min && elevation <= max) {
        result[range] = true;
        break;
      }
    }

    return result;
  }

  processBiomeRanges(data: any) {
    let biome: string = data?.biome ?? '';

    // Normalize input biome to Title Case
    biome = biome
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    // Build base result object (all false)
    const result: Record<string, boolean> = this.biomeRanges.reduce(
      (acc, range) => {
        acc[range] = false;
        return acc;
      },
      {} as Record<string, boolean>,
    );

    // If biome is empty or invalid, return all false
    if (!biome) {
      return result;
    }

    // Exact match → set true
    if (result.hasOwnProperty(biome)) {
      result[biome] = true;
    }

    return result;
  }

  private setupCoordinateHistory(): void {
    this.historySubscriprtion = this.coordService.historyRecords$.subscribe(
      (historyRecords) => {
        if (!historyRecords) return;

        this.historyRecords = historyRecords;
        this.historyRecords = historyRecords.map((item) => {
          item.selected = false;
          return item;
        });

        // Get only "map" type history
        const onlyMapHistory = historyRecords.filter(
          (record) => record.type.toLowerCase() === 'map',
        );

        // Extract and flatten movements
        const dataArrayJoined = this.mapService
          .extractMovements(onlyMapHistory)
          .reduce((acc, arr) => acc.concat(arr), []);

        // Fetch layer details
        this.radiusAndFilterSetup(dataArrayJoined, true);

        // Draw constant movement line
        this.mapService.addConstantMovmentLine(
          this.historyRecords,
          this.isHistoryAdded,
        );

        // Sort records
        this.sortHistoryRecords(historyRecords);
        this.cdr.detectChanges();
      },
    );
  }

  private radiusAndFilterSetup(
    dataArrayJoined: any[],
    isRetainZoom: boolean,
  ): void {
    const length = dataArrayJoined?.length;
    this.mapService
      .getLayerDetail(this.character_id)
      .subscribe((layers: any[]) => {
        if (layers?.length) {
          this.mapService.loadFilters(
            'radius',
            true,
            length && length > 0 ? dataArrayJoined : null,
            isRetainZoom,
            layers,
          );
        }
      
          this.cdr.detectChanges();});
  }


  private fetchFavoriteLocations(): void {
    this.dataService.getFavroiteRecordsByMapId(this.userId, 'map').subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          this.mapService?.sharedLocationLayer?.getSource()?.clear();
          this.favroiteRecords = data;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.favroiteRecords = [];
        this.toastService.showSuccess('Nothing here yet.', 'danger');
      
          this.cdr.detectChanges();},
    );
    this.favoriteRecordsService.favoriteRecords$.subscribe((data: FavoriteRecord[]) => {
      this.favroiteRecords = data || [];
      this.isRemovingFavorite = null;
      this.cdr.detectChanges();
    });
  }


  @HostListener('window:click', ['$event'])
  onClick(event: any) {
    if (
      this.mapElement &&
      this.mapElement.nativeElement.contains(event.target as HTMLElement)
    ) {
      if (this.openPinPanel) {
        this.mapService.handleMapClick(true, false);
        this.openPinPanel = false;
      } else if (this.openContentCreation) {
        this.mapService.handleMapContentClick(
          true,
          false,
          true,
          false,
          null,
          false,
        );
        this.openContentCreation = false;
      } else {
        this.mapService.handleMapClick(false, false);
        this.mapService.handleMapContentClick(
          false,
          false,
          false,
          false,
          null,
          false,
        );
      }
      this.cityMapService.cityMapVisible$.subscribe((data: any) => {
        if (data.visible === true) {
          this.isDisplayCityMap = data.visible;
          this.cityCode = data.code;
          this.coordService.historyCityRecords$.subscribe(
            (historyCityRecords) => {
              if (historyCityRecords) {
                let dataArrayJoined = [];
                const data = this.mapService.extractMovements(
                  this.historyRecords,
                );
                data.forEach((arrayInstance) => {
                  dataArrayJoined = dataArrayJoined.concat(arrayInstance);
                });
                this.historyCityRecords = historyCityRecords;
                this.mapService.addCityConstantLine(
                  historyCityRecords,
                  this.isHistoryAdded,
                );
                this.historyCityRecords = historyCityRecords;
                this.sortHistoryRecords(this.historyCityRecords);
              } else {
                this.historyCityRecords = [];
              }
            
          this.cdr.detectChanges();},
          );

          this.coordService.sharedLocationCityRecords$.subscribe((data) => {
            if (data) {
              this.citySharedLocationArr = data;
              for (let savedItem in this.citySharedLocationArr) {
                if (
                  !this.dynamicCityFavroiteForm.get(
                    'control' +
                      this.citySharedLocationArr[savedItem].id +
                      'city',
                  )
                ) {
                  this.dynamicCityFavroiteForm.addControl(
                    `control${this.citySharedLocationArr[savedItem].id}city`,
                    this.formBuilder.control(false),
                  );
                } else {
                  this.dynamicCityFavroiteForm
                    .get(
                      `control${this.citySharedLocationArr[savedItem].id}city`,
                    )
                    .setValue(this.citySharedLocationArr[savedItem].book_mark);
                }
              }
            } else {
              this.citySharedLocationArr = [];
            }
          
          this.cdr.detectChanges();});

          this.cityDataService
            .cityGetSharedLocation(
              this.character_id,
              this.map_id,
              this.cityCode,
            )
            .subscribe((citySharedLocation: any) => {
              if (citySharedLocation.res.length > 0) {
                this.citySharedLocationArr = citySharedLocation.res;
                this.coordService.setNewSharedLocationCity(
                  this.citySharedLocationArr,
                );
                for (let savedItem in this.citySharedLocationArr) {
                  this.dynamicFavroiteForm.addControl(
                    `control${this.listOfSavedItems[savedItem].id}city`,
                    this.formBuilder.control(false),
                  );
                  this.dynamicFavroiteForm
                    .get(`control${this.listOfSavedItems[savedItem].id}city`)
                    .setValue(this.listOfSavedItems[savedItem].book_mark);
                }
              } else {
                this.citySharedLocationArr = [];
              }
            
          this.cdr.detectChanges();});

          this.coordService.contentRecordsUpdatedCity$.subscribe((data) => {
            if (data) {
              this.cityContentCreatorData = data;
            } else {
              this.cityContentCreatorData = [];
            }
          
          this.cdr.detectChanges();});

          this.coordService.contentRecordsUpdatedCityByMapCode$.subscribe(
            (data) => {
              if (data) {
                this.cityPlayerContentData = data;
              } else {
                this.cityPlayerContentData = data;
              }
            
          this.cdr.detectChanges();},
          );
        } else this.cityCode = null;
      
          this.cdr.detectChanges();});
    } else if (
      this.sideInfoElement &&
      this.sideInfoElement.nativeElement.contains(event.target as HTMLElement)
    ) {
      this.sideInfoBar = true;
    } else if (
      this.cityMapElement &&
      this.cityMapElement.nativeElement.contains(event.target as HTMLElement)
    ) {
      if (this.cityOpenPanel) {
        this.cityOpenPanel = false;
        this.mapService.handleMapClick(true, true);
      } else if (this.openContentCreationCity) {
        this.mapService.handleMapContentClick(
          true,
          false,
          true,
          false,
          null,
          true,
        );
        this.openContentCreationCity = false;
      } else {
        this.mapService.handleMapClick(false, false);
        this.mapService.handleMapContentClick(
          false,
          false,
          false,
          false,
          null,
          true,
        );
      }
    }
    // else this.sideInfoBar = false;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.onResize();
    history.pushState(null, '', location.href);
    window.onpopstate = () => {
      history.go(1); // disables going back
    };
    window.dispatchEvent(new Event('resize'));
    this.intializeInfoBar();
    this.dynamicFavroiteForm = this.formBuilder.group({});
    this.dynamicCityFavroiteForm = this.formBuilder.group({});
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.userId = data.id;
      }
    
          this.cdr.detectChanges();});

    this.coordService.contentRecordsUpdated$.subscribe((data) => {
      if (data) {
        this.contentCreatorData = data;
        this.cdr.detectChanges();
      }
    });
  }

  intializeInfoBar() {
    this.infoBarService.dataRetriver$.subscribe((data) => {
      if (!data) return;

      // According to the new InfoBarMapViewService, data = { resource_values, burg_values }
      const cell = data.resource_values;
      const burg = data.burg_values;
      if (!this.map_name && cell?.map_name) {
        this.map_name = cell.map_name;
      }

      // CELL DETAILS (right panel)
      this.objectData = {
        'City Present': burg ? 'Yes' : 'None',
        Culture: cell.culture,
        Religion: cell.religion,
        State: cell.state,
        Province: cell.province,
        Biome: cell.biome,
        Elevation: cell.elevation + ' ft' || 'NA',
        Depth: cell.depth + ' ft' || 'NA',
        Population: cell.population,
        'Natural Resources': cell.basic_resources,
        'Bonus Resources': cell.bonus_resources,
        'Mineral Resources': cell.mineral_resources,
        'Farm Resources': cell.farm_resources,
        'Special Resources': cell.special_resources,
      };
            if (this.objectData.Elevation === 'undefined ft' || this.objectData.Elevation === '0 ft') {
        delete this.objectData.Elevation;
      }
      if (this.objectData.Depth === 'undefined ft' || this.objectData.Depth === '0 ft') {
        delete this.objectData.Depth;
      }

      // CITY DETAILS (left panel)
      if (burg) {
        this.cityData = {
          'City Name': burg.burg || burg.Burg,
          Capitol: burg.capital || burg.Capital || 'No',
          Citadel: burg.citadel || burg.Citadel || 'No',
          Port: burg.port || burg.Port || 'No',
          'Market Place': burg.Plaza || 'No',
          'City Walls': burg.walls || burg.Walls || 'No',
          'Religious Center':
            burg.Temple && burg.Temple.length > 0 ? 'Yes' : 'No',
          'Shanty Town':
            burg['Shanty Town'] && burg['Shanty Town'].length > 0
              ? 'Yes'
              : 'No',
          Population: burg.population || burg.Population || cell.population,
        };
        this.isCityDetailsVisible = true;
        this.isMapDetailsVisible = true;
      } else {
        this.cityData = null;
        this.isCityDetailsVisible = false;
        this.isMapDetailsVisible = true;
      }
      this.cdr.detectChanges();
    });
  }

  cellDetailsSort = (a: any, b: any): number => {
    const order = this.cellDetailsOrder;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  cityDetailsSort = (a: any, b: any): number => {
    const order = this.cityDetailsSortArray;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  getLegendDataLocal(mapcode: string, layer_name: string) {
    this.dataService
      .getLegendData(mapcode, layer_name)
      .subscribe((data: { res: any[] }) => {
        if (data.res.length > 0) {
          this.legendData = data.res;
          this.processLegendData(this.legendData);
        } else {
          this.legendData = [];
        }
      
          this.cdr.detectChanges();});
  }

  resetLayers() {
    // open on the layer last chosen for this map (e.g. after Create new
    // content -> Back), otherwise State
    this.currentLayerName = applyRememberedMapLayer(this.route.snapshot.paramMap.get('map_id'));
  }

  processLegendData(legendData: any) {
    this.legendData = legendData.map((ele) => ({
      name: ele.name,
      full_name: ele.full_name,
      color: ele.color,
    }));
  }

  toggleMenu(menuId: string, menuOption?: boolean, isOption?: string) {
    if (menuId === 'menu1' && !menuOption) {
      this.isMenu1Open = !this.isMenu1Open;
      this.isMenu2Open = false;
    } else if (menuId === 'menu2') {
      this.openPinPanel = false;

      this.isMenu2Open = menuOption;
      this.optionText = isOption;
      if (!isOption) {
        this.selectedIcon = null;
      } else if (isOption === 'Saved') {
        this.coordService.savedRecordUpdated$.subscribe((data) => {
          if (data) {
            this.listOfSavedItems = data;
            this.listOfSavedItems.forEach((item) => {
              const controlName = `control${item.id}`;

              if (!this.dynamicFavroiteForm.get(controlName)) {
                this.dynamicFavroiteForm.addControl(
                  controlName,
                  this.formBuilder.control(false),
                );
              } else {
                this.dynamicFavroiteForm
                  .get(controlName)
                  ?.setValue(item.book_mark);
              }

              // this.mapService.createAndAddFeatureToLayer(item.iconname, item.geography);
            });
          }
        
          this.cdr.detectChanges();});
      } else if (isOption === 'favorites') {
        if (this.cityCode) {
          this.cityDataService
            .getCityFavroiteData(this.character_id, this.map_id, this.cityCode)
            .subscribe(
              (data: any) => {
                if (data.length > 0) {
                  this.cityFavroiteRecords = data;
                }
              
          this.cdr.detectChanges();},
              (error) => {
                this.cityFavroiteRecords = [];
              
          this.cdr.detectChanges();},
          );
        }
      }
    } else if (menuId === 'close') {
      this.selectedIcon = null;
      this.isMenu1Open = false;
      this.isMenu2Open = false;
    } else if (menuId === 'menu2' && isOption === 'playersContent') {
    }

    //return this.mapService.();
  }

  removeFromFavroite(record: FavoriteRecord) {
    this.isRemovingFavorite = record.wp_content_usage_id;

    this.dataService.saveContentToFavorites(this.userId, record.wp_content_usage_id).subscribe({
      next: (res: any) => {
        this.toastService.showSuccess(res.message, 'success');
        this.favoriteRecordsService.loadFavoriteRecords(this.userId, 'map', true);
      
          this.cdr.detectChanges();},
      error: () => {
        this.isRemovingFavorite = null;
      
          this.cdr.detectChanges();}
    });
  }

  getPlayerLocationHistory(isHistoryAdded) {
    this.dataService
      .getHistoryDetailByCharacterId(this.character_id, this.map_id)
      .subscribe(
        (res: any) => {
          if (res && res.length > 0) {
            this.historyRecords = res;
            this.historyRecords = this.historyRecords.map((item) => {
              item.selected = false;
              return item;
            });
            const onlyMapHistory =
              this.historyRecords.filter(
                (record) => record.type.toLowerCase() === 'map',
              ) || [];
            const data = this.mapService.extractMovements(onlyMapHistory);

            setTimeout(() => {
              let dataArrayJoined = [];

              data.forEach((arrayInstance) => {
                dataArrayJoined = dataArrayJoined.concat(arrayInstance);
              });
              this.radiusAndFilterSetup(dataArrayJoined, false);
              this.mapService.map.updateSize();
            }, 0);
            this.historyRecords = this.sortHistoryRecords(this.historyRecords);
            this.mapService.addConstantMovmentLine(
              this.historyRecords,
              isHistoryAdded,
            );
          } else {
            setTimeout(() => {
              this.radiusAndFilterSetup(undefined, false);
              this.mapService.map.updateSize();
            }, 0);
          }
        
          this.cdr.detectChanges();},
        (error) => {
          this.cdr.detectChanges();},
      );
  }

  getPlayerCityLocationHistory() {
    this.cityDataService
      .getCityHistoryData(this.character_id, this.map_id, this.cityCode)
      .subscribe((res: any) => {
        if (res.res.length > 0) {
          this.historyCityRecords = res.res;
          this.historyCityRecords = this.sortHistoryRecords(
            this.historyCityRecords,
          );
        } else {
          this.historyCityRecords = [];
        }
      
          this.cdr.detectChanges();});
  }

  removeCityLayer() {
    this.mapService.removeCityLayer();
    setTimeout(() => this.map.updateSize(), 300);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize')); // Simulate window resize
    }, 300);

    this.isDisplayCityMap = false;
    this.cityOpenPanel = false;
  }

  editDetail(record, isCity) {
    const modalRef = this.modalService.open(PlayerStoryComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.updateStory.details = record.details;
    modalRef.componentInstance.updateStory.title = record.title;
    modalRef.result.then((result) => {
      if (result) {
        const recordDetails = result.value.details;
        const recordTitle = result.value.title;

        if (!isCity) {
          record.details = result.value.details;
          record.title = result.value.title;
          this.dataService.updateHistoryRecord(record).subscribe(
            (data) => {
              if (data) {
                this.toastService.showSuccess(
                  'Player History Updated Successfully !!!',
                  'success',
                );
              }
            
          this.cdr.detectChanges();},
            (error) => {
              record.details = recordDetails;
              record.title = recordTitle;
            
          this.cdr.detectChanges();},
          );
        } else {
          record.details = result.value.details;
          record.title = result.value.title;

          this.cityDataService.updateCityMovmentHistory(record).subscribe(
            (data) => {
              if (data) {
                this.toastService.showSuccess(
                  'City Party Journal Updated Successfully !!!',
                  'success',
                );
              }
            
          this.cdr.detectChanges();},
            (error) => {
              record.details = recordDetails;
              record.title = recordTitle;
            
          this.cdr.detectChanges();},
          );
        }
      }
    
          this.cdr.detectChanges();});
  }
  filterlayers(layers) {
    this.newLayers = layers.filter((lyr) => lyr.toggle == true);
    return this.newLayers;
  }

  changeToggleLayer(item: any) {
    // each layer toggles independently, so a bare map plus any combination of
    // overlays can be shown at once, rather than exactly one at a time
    item.checked = !item.checked;
    const currentLayer = this.newLayers.find((lyr) => lyr.checked === true);
    if (currentLayer) {
      rememberMapLayer(this.map_id, currentLayer.name);
      this.currentLayerName = currentLayer.name;
      this.currentLayerWikiName = currentLayer.label?.toLowerCase();
      this.getLegendDataLocal(this.map_id, currentLayer.name);
    }
    this.mapService.filterAndToggleLayers(this.newLayers);
  }

  selectedIconHandle(isCity: boolean, selectedIconOption?: string) {
    if (!isCity) this.openPinPanel = !this.openPinPanel;
    else this.cityOpenPanel = !this.cityOpenPanel;
    this.selectedIcon = selectedIconOption;
  }

  historyRecordSelected(index, recordsCords) {
    this.isHistoryAdded = true;
  }

  ngOnDestroy(): void {
    window.onpopstate = null;
    this.mapService.removeOldMap();
    this.cityMapVisibleSubscription?.unsubscribe();
    this.infoBarSubscription?.unsubscribe();
    this.mapService.unbindSingleClick();
    this.historySubscriprtion?.unsubscribe();
  }

  handleFavoriteClick(dataObj) {
    this.dataService.updateFavroiteStatus(dataObj).subscribe((data) => {
      if (data) {
        this.toastService.showSuccess(
          'Favorite Deleted successfully !!!',
          'success',
        );
        this.fetchFavoriteLocations(); // Refresh the favorite locations after toggling
      }
    
          this.cdr.detectChanges();});
  }

  handleFavoriteClickCity(dataObj) {
    this.cityDataService.toggleBookMark(dataObj).subscribe((data) => {
      if (data) {
        this.toastService.showSuccess(
          'Toggled Favroite successfully !!!',
          'success',
        );
      }
    
          this.cdr.detectChanges();});
  }

  editRecord(record) {
    this.mapService.handleMapContentClick(
      true,
      false,
      true,
      false,
      record,
      false,
    );
  }

  editCityContent(record) {
    this.mapService.handleMapContentClick(
      true,
      false,
      true,
      false,
      record,
      true,
    );
  }

  addContentPlayerView() {
    const modal = this.modalService.open(AddContentComponent, {
      size: 'lg',
    });
    modal.componentInstance.isModalOpen = true;
  }

  deleteRecord(id) {
    this.dataService.deleteContentById(id).subscribe((data) => {
      if (data) {
        this.toastService.showSuccess(
          'Record Deleted Successfully !!!',
          'success',
        );
        this.getAllRecords();
      }
    
          this.cdr.detectChanges();});
  }

  deleteCityContentRecord(id) {
    this.cityDataService.deleteCityContentById(id).subscribe((data) => {
      if (data) {
        this.toastService.showSuccess(
          'Record Deleted Successfully !!!',
          'success',
        );
        // this.getAllCityContentRecords();
      }
    
          this.cdr.detectChanges();});
  }

  getAllRecords() {
    forkJoin({
      contentCreator: this.dataService.getContentDataByMapId(
        this.userId,
        this.map_id,
      ),
      mapContentCreator: this.dataService.getContentDataOfPlayersByMapCode(
        this.map_id,
      ), // <-- your 2nd API here
    }).subscribe(
      (result: {
        contentCreator: { results: ContentData[] };
        mapContentCreator: { res: any[] };
      }) => {

        if (result.contentCreator) {
          ;
          this.contentCreatorData = result.contentCreator.results;
          this.coordsArrOfPointsUser = this.extractCoordinatesFromPins(
            this.contentCreatorData,
          );
          // Perform your action with the data
          this.mapService.addDifferentContentPin(
            true,
            this.coordsArrOfPointsUser,
            false,
          );

          // if (result.mapContentCreator.res) {
          //   // Do something with the second API result
          //   this.playerCreatorData = result.mapContentCreator.res;
          //   this.playerCreatorData = this.playerCreatorData.filter(
          //     (ele) => ele.user_id !== this.userId,
          //   );
          //   const rawCoords = this.playerCreatorData.map(
          //     (ele) => ele.coordslocationarr,
          //   );
          //   const parsedCoords = this.parseStringCoordinates(rawCoords);
          //   this.coordsArrOfPointsPlayer = {
          //     coords: parsedCoords,
          //     idArr: this.playerCreatorData.map(ele => ele.id || 0)
          //   };
          //   this.mapService.addDifferentContentPin(
          //     false,
          //     this.coordsArrOfPointsPlayer,
          //     true,
          //     this.playerCreatorData,
          //   );
          // }
        }

        // Or combine both results in some logic
        // ...
      
          this.cdr.detectChanges();},
    );
  }

  openSideDropdownOption() {
    this.showDropdown = !this.showDropdown;
    this.showItemDetailsBox = false; // Closes the item details box when dropdown is opened
  }

  setSelectOption(option: string) {
    this.selectedOption = option;
    this.showItemDetailsBox = true;
    this.showDropdown = false; // the list closes once a panel is chosen
  }

  toggleCultureList() {
    this.isCultureVisible = !this.isCultureVisible;
  }

  toggleMapDetails() {
    this.sideInfoBar = true;
    this.isMapDetailsVisible = !this.isMapDetailsVisible;
    return this.sideInfoBar;
  }

  onRightClickPopup(event: MouseEvent) {
    event.preventDefault(); // Prevent the default context menu

    // keep the menu on screen near the right/bottom edges
    this.menuPosition.x = Math.min(event.clientX, window.innerWidth - 260);
    this.menuPosition.y = Math.min(event.clientY, window.innerHeight - 200);

    this.showMenu = true;

    this.newFavoriteCoordinates = this.mapService.map.getEventCoordinate(
      event,
    ) as [number, number];
  }

  openPlaceContentModal() {
    this.showMenu = false;
    const modalRef = this.modalService.open(PlaceContentModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
    });

    modalRef.result.then((selectedContent: ContentData) => {
      if (selectedContent) {
        const payload = {
          wp_product_id: selectedContent.wp_product_id,
          content_id: selectedContent.id,
          wp_user_id: this.userId,
          context: 'map' as const,
          map_id: String(this.map_id),
          city_id: null,
          latitude: this.newFavoriteCoordinates[0],
          longitude: this.newFavoriteCoordinates[1],
          label: selectedContent.content_title
        };

        this.isLoading = true;
        this.dataService.contentAttach(payload).subscribe({
          next: () => {
            this.isLoading = false;
            this.toastService.showSuccess('Content placed.', 'success');
            this.getAllRecords(); // Refresh pins
          
          this.cdr.detectChanges();},
          error: (err) => {
            this.isLoading = false;
            console.error('Error attaching content:', err);
            this.toastService.showSuccess("We couldn't place this content. Please try again.", 'danger');
          
          this.cdr.detectChanges();},
        });
      }
    
          this.cdr.detectChanges();});
  }

  saveToFavourite() {
    this.showMenu = false;
    const modalRef = this.modalService.open(CategoryPlayerViewModalComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.result.then((res) => {
      if (res) {
        const obj: any = {
          iconname: res.selectedIcon,
          game_id: this.game_id,
          character_id: res.character_id
            ? res.character_id.map((char) => char.character_id)
            : [this.character_id],
          geography:
            this.newFavoriteCoordinates[0].toString() +
            ',' +
            this.newFavoriteCoordinates[1].toString(),
          color: res.color,
          category: res.category,
          details: res.details,
          mapcode: this.map_id,
        };

        obj.citycode = this.cityCode;
        this.playerViewService.addLocationPointInfo(obj).subscribe((data) => {
          this.fetchFavoriteLocations();
        
          this.cdr.detectChanges();});
      }
    
          this.cdr.detectChanges();});
  }

  onOptionClick(option: string) {
    this.toastService.showNote(`${option} selected`);
    this.closeMenu();
  }

  closeMenu() {
    this.showMenu = false;
  }

  toggleCityMapDetails() {
    this.sideInfoBar = true;
    this.isCityDetailsVisible = !this.isCityDetailsVisible;
    return this.sideInfoBar;
  }

  triggerZoomIn() {
    this.mapService.zoomIn();
  }

  triggerZoomOut() {
    this.mapService.zoomOut();
  }
  triggerTokenZoom() {
    this.mapService.zoomToExtent('playermap');
  }
  closeSecondMenu() {
    this.showItemDetailsBox = false;
    this.selectedOption = '';
  }

  sortHistoryRecords(records: any[]) {
    return records.sort((a, b) => {
      const dateA: any = new Date(a.timestamp);
      const dateB: any = new Date(b.timestamp);
      return dateB - dateA;
    });
  }

  continuePlaying() {
    this.router.navigate(
      [
        '/city-map-view/' +
          this.playerlistdata.city_id +
          '/' +
          this.map_id +
          '/' +
          (this.game_id ? this.game_id : 'null') +
          '/' +
          (this.character_id ? this.character_id : 'null'),
      ],
      {
        queryParams: {
          token: this.playerlistdata.cropped_image,
          isLoadToken: true,
          isPlaceToken: this.playerlistdata.current_location,
          backRoute: 'map-view-player',
          game_system: this.playerlistdata.game_details[0]?.game_system || null,
          isMovable:
            !(
              this.playerlistdata.game_details[0]?.is_active ||
              this.playerlistdata.is_retired ||
              this.playerlistdata.is_dead
            ) || false,
        },
      },
    );
  }

  navigateToCityNameWiki() {
    this.wikiService.openCityWiki(
      this.cityData['City Name'],
      this.map_id,
      this.map_name,
    );
  }

  onDynamicDataClick(dataName: string) {
    this.wikiService.openWiki(
      this.currentLayerWikiName,
      dataName,
      this.map_id,
      this.map_name,
    );
  }

  navigateToWikiWorld(map_name?: string) {
    this.wikiService.openMapWiki(this.map_id, map_name || this.map_name);
  }

  hoveredResource: any = null;
  tooltipStyle: any = {};

  showResourceTooltip(event: MouseEvent, item: any): void {
    if (!item) return;
    this.hoveredResource = typeof item === 'string' ? { name: item } : item;
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const rect = target.getBoundingClientRect();
      const tooltipWidth = 330;
      const left = Math.max(10, rect.left - tooltipWidth - 15);
      const top = Math.max(10, Math.min(window.innerHeight - 240, rect.top - 20));
      this.tooltipStyle = {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }

  hideResourceTooltip(): void {
    this.hoveredResource = null;
  }

  isResourceField(key: string | any): boolean {
    const resourceKeys = [
      'Natural Resources',
      'Bonus Resources',
      'Farm Resources',
      'Mineral Resources',
      'Special Resources',
    ];
    return resourceKeys.includes(key);
  }

  splitResources(value: string | any): any[] {
    if (!value || value === 'None') return [];
    if (Array.isArray(value)) {
      return value.map((item) => {
        if (typeof item === 'string') {
          return { name: item, description: '', production: 0, economy: 0, rarity: 0, processing: 0 };
        }
        return item;
      });
    }
    if (typeof value === 'string') {
      if (value.toLowerCase() === 'none') return [];
      return value.split(',').map((v) => ({
        name: v.trim(),
        description: '',
        production: 0,
        economy: 0,
        rarity: 0,
        processing: 0
      }));
    }
    return [];
  }

  onResourceClick(resource: string): void {
    this.wikiService.openResourceWiki(resource);
  }

  isLinkField(key: string | any): boolean {
    const linkKeys = ['State', 'Province', 'Culture', 'Religion', 'Biome'];
    return linkKeys.includes(key);
  }

  navigateToDynamicLink(key: string | any, value: string | any): void {
    this.wikiService.openWiki(key, value, this.map_id, this.map_name);
  }

  toggleGMTools() {
    this.showMenu = false;
    this.selectedOption = 'GMTools';
    this.showItemDetailsBox = true;
  }

  openNoteModal(isPrivate: boolean) {
    const modalRef = this.modalService.open(NoteListComponent, {
      centered: true,
      backdrop: 'static',
      size: 'md',
    });

    modalRef.componentInstance.game_id = this.game_id;
    modalRef.componentInstance.noteType = isPrivate ? 'private' : 'public';
    modalRef.componentInstance.isFilter = true;
  }

  navigateToElevationLink() {
    const url = `${WORLD_TUMBLER_URL}/elevations/elevations`;
    window.open(url, '_blank');
  }

  journalCheckBoxChange(event, index) {
    const journalEntry = this.historyRecords.find(
      (entry) => entry.id == event.target.value,
    );
    journalEntry.selected = event.target.checked;
    if (!journalEntry.selected) {
      this.mapService.removeRedLineOfPath(journalEntry);
    } else {
      this.mapService.addLineOfPath(journalEntry);
    }
  }
  browseWpStore() {
    // Opens the store filtered to this map's genre. The StoreLinkService
    // opens the in-app store.
    this.showMenu = false;
    this.dataService.getMapGenre(this.map_id).subscribe((data: any) => {
      if (data?.res) {
        const actualGenre = data.res
        this.storeLinks.openStore({ genre: actualGenre });
      }
      else {
        this.storeLinks.openStore();
      }
      this.cdr.detectChanges();
    }, () => {
      this.storeLinks.openStore();
      this.cdr.detectChanges();
    });
  }

  constructParam(genre: string) {
    const groupGenre = ['Science Fiction & Science Fantasy (Traveller, etc)', 'Modern & Horror (Call of Cthulhu, etc)', 'Fantasy (Dungeons & Dragons, etc)', 'Fantasy (Dungeons & Dragons, etc)']
    const paramsGenre = ['scifi', 'modern-horror', 'fantasy']
    const index = groupGenre.indexOf(genre);
    if (index !== -1) {
      return paramsGenre[index];
    }
    return '';
  }
}
